import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const CheckmarkSmall = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m6.589 13.128 3.784 3.006 7.038-8.267'
        stroke='currentColor'
        strokeWidth='1.691'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='m6.589 13.128 3.784 3.006 7.038-8.267'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    )}
  </IconBase>
);
